<template>
    <v-app>
        <app-top-bar :menu="menu" :color="'linear-gradient(135deg, #1E3C72 0%, #2A5298 100%)'" :moduleName="'MODULE SELECTOR'"/>
        <v-main>
        <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import AppTopBar from '../components/AppTopAndSideBar.vue';

export default {
  components: { AppTopBar},
    name: 'AuthLayout',
    data: () => ({
        menu: [
            { text: 'Landing Page', icon: 'mdi-web', routerName: 'Landing' },
            { text: 'All Modules', icon: 'mdi-view-dashboard', routerName: 'ModuleSelector' },
        ],
    }),
};
</script>